module.exports = __webpack_public_path__ + "assets/img/de-917449e7.png";